import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortArrowUnsorted = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("polygon", { points: "15.17 15 13 17.17 13 6.83 15.17 9 16.58 7.59 12 3 7.41 7.59 8.83 9 11 6.83 11 17.17 8.83 15 7.42 16.41 12 21 16.59 16.41 15.17 15" })
});
export default SvgSortArrowUnsorted;
